<template>
  <div class="invoice">
    <div v-if="isShowTitle" class="title">专用发票</div>
    <div class="tips">
      提示：修改或完善开票信息，请前往 发票管理->发票助手
    </div>
    <div class="content">
      <div class="invoice-form">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="160px"
          label-suffix="："
          size="small"
        >
          <el-form-item label="单位名称" prop="companyName">
            <span>{{ form.companyName || '-' }}</span>
          </el-form-item>
          <el-form-item label="纳税人识别号" prop="companyTaxNo">
            <span>{{ form.companyTaxNo || '-' }}</span>
          </el-form-item>
          <el-form-item label="注册地址" prop="companyAddress">
            <span v-if="readOnly">{{ form.companyAddress || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.companyAddress"
              maxlength="50"
              show-word-limit
              placeholder="请输入注册地址"
            />
          </el-form-item>
          <el-form-item label="注册电话" prop="companyMobile">
            <span v-if="readOnly">{{ form.companyMobile || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.companyMobile"
              placeholder="请输入注册电话"
              maxlength="20"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="开户银行" prop="companyBankName">
            <span v-if="readOnly">{{ form.companyBankName || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.companyBankName"
              placeholder="请输入开户银行"
              maxlength="100"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="银行账号" prop="companyBankAccount">
            <span v-if="readOnly">{{
              form.companyBankAccount | bankFilter
            }}</span>
            <el-input
              v-else
              v-model.trim="form.companyBankAccount"
              placeholder="请输入银行账号"
              maxlength="30"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="收票人姓名" prop="employeeName">
            <span v-if="readOnly">{{ form.employeeName || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.employeeName"
              placeholder="请输入收票人姓名"
              maxlength="10"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="收票人手机号" prop="employeeMobile">
            <span v-if="readOnly">{{ form.employeeMobile || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.employeeMobile"
              placeholder="请输入收票人手机号"
              maxlength="20"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="收票人邮箱" prop="employeeEmail">
            <span v-if="readOnly">{{ form.employeeEmail || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.employeeEmail"
              placeholder="请输入收票人邮箱"
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="邮寄地址" prop="receiveAddress">
            <span v-if="readOnly">{{ form.receiveAddress || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.receiveAddress"
              placeholder="请输入邮寄地址"
              maxlength="100"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="上传专票证明附件" prop="attachmentId">
            <upload
              ref="upload"
              :props-data="{
                bizType: 'invoice_paper',
                attachmentType: 'invoice_paper',
                groupIdBefore: form.attachmentId,
                disabled: readOnly,
                beforeUpload: beforeUpload,
                onSuccess: groupId => (form.attachmentId = groupId),
                onCompleteDelete: () => (form.attachmentId = '')
              }"
            >
              <div slot="tip" class="important-tip m-t-10">
                支持：jpg、png、bmp、jpeg，图片大小不超过5M，只可上传1个
              </div>
            </upload>
            <download-file
              v-if="!readOnly"
              class="download-file"
              download-link="/resources/专用发票信息证明.docx"
            >
              <span class="text-primary">下载专票证明模版</span>
            </download-file>
          </el-form-item>
        </el-form>

        <template v-if="!readOnly">
          <!-- 提示信息 -->
          <div v-if="!invoiceInfo.id" class="edit-tip-message">
            务必保证模版内容与填写信息一致，当模版不符合要求时，将自动开出电子普通发票
          </div>
          <div v-else class="edit-tip-message">
            您已修改部分信息，请重新上传专票证明模版，务必保证模版与填写信息一致
          </div>

          <!-- 协议勾选 -->
          <div class="register-agreement">
            <el-checkbox v-model="agree">我已阅读并同意</el-checkbox>
            <span class="agreement-button">
              <el-button
                type="text"
                @click="agreementDialogVisible = true"
              >增值税专用发票抬头确认书</el-button>
            </span>
          </div>
        </template>

        <div class="invoice-form-operate">
          <el-button
            v-if="readOnly"
            size="small"
            @click="editInvoiceInfo"
          >修改</el-button>
          <template v-else>
            <el-button
              v-if="invoiceInfo.id"
              size="small"
              @click="cancel"
            >取消</el-button>
            <el-button
              type="primary"
              size="small"
              @click="saveInvoiceInfo"
            >保存</el-button>
          </template>
        </div>
      </div>
    </div>

    <el-dialog
      title="增值税专用发票抬头确认书"
      :visible.sync="agreementDialogVisible"
      width="70rem"
      :close-on-click-modal="false"
      append-to-body
      center
      class="dialog"
      :before-close="() => (agreementDialogVisible = false)"
    >
      <paper-invoice-copywriter />
      <el-button
        slot="footer"
        type="primary"
        @click="agreementDialogVisible = false"
      >确认</el-button>
    </el-dialog>
  </div>
</template>

<script>
// 组件
import Upload from '@/components/Upload'
import DownloadFile from '@/components/DownloadFile'
import PaperInvoiceCopywriter from '@/components/AgreementText/PaperInvoiceCopywriter'
// 字典
import { invoiceTypeDict, isCompanyDict } from '@/dictionary/financial'
// 工具
import { formValid, strUtil } from 'jczh-ui'
// 接口
import {
  addInvoiceApi,
  changeInvoiceApi,
  getInvoiceApi
} from '@/api/financial/invoice'

/**
 * @description 专用发票组件
 */
export default {
  name: 'SpecialInvoice',

  components: {
    Upload,
    DownloadFile,
    PaperInvoiceCopywriter
  },

  filters: {
    bankFilter(bankCard) {
      return bankCard ? strUtil.bankCardDivision(bankCard) : '-'
    }
  },

  props: {
    companyId: {
      type: [String, Number],
      required: true
    },

    // 发票地址id
    invoiceAddressId: {
      type: [String, Number],
      default: ''
    },

    // 当前用户是否为企业员工
    isEmployee: {
      type: Boolean,
      default: false
    },

    // 是否显示标题
    isShowTitle: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      readOnly: true,
      agreementDialogVisible: false,
      agree: false,
      form: {
        id: undefined,
        invoiceType: invoiceTypeDict.SPECIAL_PAPER_INVOICE.value,
        companyId: undefined,
        companyName: undefined,
        companyTaxNo: undefined,
        companyAddress: undefined,
        companyMobile: undefined,
        companyBankName: undefined,
        companyBankAccount: undefined,
        employeeName: undefined,
        employeeMobile: undefined,
        employeeEmail: undefined,
        receiveAddress: undefined,
        attachmentId: undefined,
        isCompany: isCompanyDict.COMPANY.value
      },
      rules: {
        companyName: {
          required: true,
          message: '请输入单位名称',
          trigger: 'blur'
        },
        companyTaxNo: {
          required: true,
          message: '请输入纳税人识别号',
          pattern: /^[a-zA-Z\d]*$/g,
          trigger: 'blur'
        },
        companyAddress: {
          required: true,
          message: '请输入注册地址',
          trigger: 'blur'
        },
        companyMobile: {
          required: true,
          message: '请输入注册电话号码',
          trigger: 'blur'
        },
        companyBankName: {
          required: true,
          message: '请输入开户银行',
          trigger: 'blur'
        },
        companyBankAccount: {
          required: true,
          message: '请输入开户银行账号',
          trigger: 'blur'
        },
        employeeName: {
          required: true,
          message: '请输入收票人姓名',
          trigger: 'blur'
        },
        employeeMobile: {
          required: true,
          message: '请输入收票人手机号码',
          trigger: 'blur'
        },
        employeeEmail: [
          {
            required: true,
            message: '请输入收票人邮箱地址',
            trigger: 'blur'
          },
          formValid.emailRegular
        ],
        receiveAddress: {
          required: true,
          message: '请输入邮寄地址',
          trigger: 'blur'
        },
        attachmentId: {
          required: true,
          message: '请上传附件',
          trigger: 'blur'
        }
      },
      invoiceInfo: {
        // 单位名称,
        companyName: undefined,
        // 纳税人识别号
        companyTaxNo: undefined,
        // 发票id
        id: undefined,
        // 注册地址
        companyAddress: undefined,
        // 注册电话
        companyMobile: undefined,
        // 开户银行
        companyBankName: undefined,
        // 开户银行账号
        companyBankAccount: undefined,
        // 收票人姓名
        employeeName: undefined,
        // 收票人手机
        employeeMobile: undefined,
        // 收票人邮箱
        employeeEmail: undefined,
        // 邮寄地址
        receiveAddress: undefined,
        // 附件id
        attachmentId: undefined
      }
    }
  },

  computed: {
    editInvoiceInfoApi() {
      return this.invoiceInfo.id ? changeInvoiceApi : addInvoiceApi
    }
  },

  watch: {
    companyId: {
      handler(val) {
        if (val) {
          this.clearInvoiceInfo()
          this.getInvoiceInfo()
        }
      },
      immediate: true
    },

    invoiceAddressId: {
      handler(val) {
        if (val) {
          this.clearInvoiceInfo()
          this.getInvoiceInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    // 获取发票信息
    getInvoiceInfo() {
      getInvoiceApi({
        type: invoiceTypeDict.SPECIAL_PAPER_INVOICE.value,
        companyId: this.companyId,
        invoiceAddressId: this.invoiceAddressId,
        isCompany: this.isEmployee
          ? isCompanyDict.COMPANY.value
          : isCompanyDict.PERSONAL.value
      })
        .then(res => {
          this.readOnly = Boolean(res.data?.id)
          // if (this.readOnly) {
          //   // 如果查询发票信息有id
          //   this.invoiceInfo = Object.assign({}, this.invoiceInfo, res.data)
          // }
          this.invoiceInfo = Object.assign({}, this.invoiceInfo, res.data || {})

          this.form = Object.assign({}, this.form, res.data)
          this.form.invoiceType = invoiceTypeDict.SPECIAL_PAPER_INVOICE.value

          this.$emit('getInvoiceInfo', this.invoiceInfo)
        })
        .catch(err => {
          console.error('获取发票信息失败', err)
          this.$message.error(err?.data?.message || '获取专用发票信息失败')
        })
    },

    // 编辑发票信息
    editInvoiceInfo() {
      this.readOnly = false
    },

    // 取消编辑
    cancel() {
      const formKeys = Object.keys(this.form)
      formKeys.forEach(key => {
        this.form[key] = this.invoiceInfo[key]
      })
      this.form.invoiceType = invoiceTypeDict.SPECIAL_PAPER_INVOICE.value
      this.readOnly = true
    },

    // 保存发票信息
    async saveInvoiceInfo() {
      if (!this.$refs.upload.uploadComplete()) return

      try {
        if (!this.agree) {
          this.$message.warning('请先同意《增值税专用发票抬头确认书》')
          return
        }
        if (!(await this.validInvoiceForm())) return
        await this.$confirm('是否保存发票信息', '系统提示', {
          type: 'warning'
        })
        if (this.companyId) {
          this.form.companyId = this.companyId
        }

        // 如果当前用户为企业员工，则isCompany为1，否则为0
        this.form.isCompany = this.isEmployee
          ? isCompanyDict.COMPANY.value
          : isCompanyDict.PERSONAL.value

        const res = await this.editInvoiceInfoApi(this.form)
        this.readOnly = true
        this.$message.success(res?.data?.message || '保存成功')
        await this.getInvoiceInfo()
      } catch (err) {
        if (err?.data) {
          this.$message.error(err?.data?.message || '保存失败')
        }
      }
    },

    // 表单校验
    async validInvoiceForm() {
      try {
        await this.$refs.form.validate()
        return true
      } catch (err) {
        this.$message.error('表单填写有误，请按照提示要求填写')
        return false
      }
    },

    // 附件上传前的验证函数
    beforeUpload(file) {
      const isImg =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'
      const isLt5M = file.size / 1024 / 1024 <= 5
      if (!isImg) {
        this.$message.error('上传文件类型错误，请依照说明信息上传正确的文件')
      }
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!')
      }
      return isLt5M && isImg
    },

    // 清空表单数据
    clearInvoiceInfo() {
      this.invoiceInfo = {
        // 单位名称,
        companyName: undefined,
        // 纳税人识别号
        companyTaxNo: undefined,
        // 发票id
        id: undefined,
        // 注册地址
        companyAddress: undefined,
        // 注册电话
        companyMobile: undefined,
        // 开户银行
        companyBankName: undefined,
        // 开户银行账号
        companyBankAccount: undefined,
        // 收票人姓名
        employeeName: undefined,
        // 收票人手机
        employeeMobile: undefined,
        // 收票人邮箱
        employeeEmail: undefined,
        // 邮寄地址
        receiveAddress: undefined,
        // 附件id
        attachmentId: undefined
      }

      this.form = {
        id: undefined,
        invoiceType: invoiceTypeDict.SPECIAL_PAPER_INVOICE.value,
        companyId: undefined,
        companyName: undefined,
        companyTaxNo: undefined,
        companyAddress: undefined,
        companyMobile: undefined,
        companyBankName: undefined,
        companyBankAccount: undefined,
        employeeName: undefined,
        employeeMobile: undefined,
        employeeEmail: undefined,
        receiveAddress: undefined,
        attachmentId: undefined,
        isCompany: isCompanyDict.COMPANY.value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 20px;
    color: $text-color;
  }
  .content {
    .invoice-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      ::v-deep .el-form {
        width: 400px;
        .el-form-item {
          margin-bottom: 20px;
        }

        &.detail-form {
          .el-form-item {
            margin-bottom: 0;
          }
        }
      }

      .invoice-form-operate {
        text-align: center;
      }
    }

    .edit-tip-message {
      margin-bottom: 20px;
      color: $danger-color;
      font-size: 14px;
    }

    .download-file {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
      color: $primary-color;
      font-size: 12px;
    }

    .important-tip {
      font-size: 12px;
      color: $text-second-color;
      line-height: 1.2;
    }

    .register-agreement {
      margin-bottom: 20px;

      .el-checkbox__label {
        line-height: 1;
        font-size: 12px;
      }

      .agreement-button {
        &::before {
          content: '《';
        }

        &::after {
          content: '》';
        }

        ::v-deep .el-button {
          padding: 0;
        }
      }
    }
  }
}
</style>
